var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information mx-auto",style:({width: '880px'})},[_c('ContainerInfo',{staticClass:"mb-5"}),_c('ContainerSetting')],1)}
var staticRenderFns = []

export { render, staticRenderFns }